import React from 'react';
import Box from 'grommet/components/Box';
import WarningIcon from 'grommet/components/icons/base/Alert';
import Label from 'grommet/components/Label';
import * as Constants from '../Redux/action_types/EPAConstants.js';

const checkPath = (text) => window.location.href.toUpperCase().indexOf(text.toUpperCase()) !==-1;



const Warning = (props) => {
    const { isEnabled, message, history } = props;
    let displayStyle = checkPath(Constants.HPECP_SIZER) && !isEnabled ?
        { display: 'block' } : { display: 'none' }
    let optionalMessage = checkPath(Constants.HPECP_CONTAINER_PAGE.toUpperCase());
    
    return (
        <Box pad='none' margin='none' style={displayStyle} >
            {
                <Box size='xlarge' direction='row' margin='none' pad='small' style={{ backgroundColor: 'yellow' }}>
                    <WarningIcon size='small' margin='small' type='status' />
                    <Label style={{marginLeft:'10px'}}size='medium' margin='none'>{message}</Label>
            {!optionalMessage ? <Label size='medium' margin='none' style={{marginLeft:'10px',cursor:'pointer', textDecoration:'underline'}} onClick={() => history.push('/Build/HPEEzmeralRuntimeEnterprise')} >{Constants.NAV_MESSAGE}</Label> :''}
                </Box>
            }
        </Box>
    );
}

export default Warning;



// WEBPACK FOOTER //
// ./src/SizerUI/SizerScreens/Warning.js